
interface Product {
  id: number;
  title: string;
  category: string;
  brand: string;
  model: string;
  certification: string;
  status: string;
  image: string;
  description: string;
}

interface ProductDetailHeroProps {
  product: Product;
}

export default function ProductDetailHero({ product }: ProductDetailHeroProps) {
  return (
    <section className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Breadcrumb */}
        <nav className="mb-8">
          <ol className="flex items-center space-x-2 text-sm text-gray-600">
            <li><a href="/" className="hover:text-red-600">Home</a></li>
            <li><i className="ri-arrow-right-s-line"></i></li>
            <li><a href="/products" className="hover:text-red-600">Products</a></li>
            <li><i className="ri-arrow-right-s-line"></i></li>
            <li className="text-gray-900">{product.title}</li>
          </ol>
        </nav>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Product Image */}
          <div className="relative">
            <img
              src={product.image}
              alt={product.title}
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
            <div className="absolute top-4 right-4 bg-green-500 text-white px-3 py-1 rounded-full text-sm font-medium">
              {product.status}
            </div>
          </div>

          {/* Product Details */}
          <div className="space-y-6">
            <div>
              <p className="text-red-600 font-medium mb-2">{product.category}</p>
              <h1 className="text-4xl font-bold text-gray-900 mb-4">{product.title}</h1>
              <p className="text-lg text-gray-600 leading-relaxed">{product.description}</p>
            </div>

            {/* Product Info Grid */}
            <div className="grid grid-cols-2 gap-4 py-6 border-t border-b border-gray-200">
              <div>
                <p className="text-sm text-gray-500">Brand</p>
                <p className="font-semibold text-gray-900">{product.brand}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Model</p>
                <p className="font-semibold text-gray-900">{product.model}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Certification</p>
                <p className="font-semibold text-green-600">{product.certification}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Status</p>
                <p className="font-semibold text-green-600">{product.status}</p>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="/contact"
                className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                Request Quote
              </a>
              <button className="border border-gray-300 hover:border-red-600 text-gray-700 hover:text-red-600 px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                Download Datasheet
              </button>
            </div>

            {/* Share Buttons */}
            <div className="flex items-center space-x-4 pt-4">
              <span className="text-sm text-gray-500">Share:</span>
              <button className="text-gray-400 hover:text-blue-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </button>
              <button className="text-gray-400 hover:text-green-600 transition-colors cursor-pointer">
                <i className="ri-whatsapp-fill text-xl"></i>
              </button>
              <button className="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer">
                <i className="ri-mail-fill text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
